/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Price_Includes_Material_HintInputs */

const vi_product_price_includes_material_hint = /** @type {(inputs: Product_Price_Includes_Material_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tick nếu giá sản phẩm đã gồm giá vật tư (chè + hộp). Khi lên đơn sẽ có nút tách/gộp giá vật tư để tính chiết khấu riêng cho đại lý.`)
};

/**

* @param {Product_Price_Includes_Material_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_price_includes_material_hint = /** @type {((inputs?: Product_Price_Includes_Material_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Price_Includes_Material_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_price_includes_material_hint(inputs)
});